// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3BYgn","signatureButtonsRight":"ModalSign_signatureButtonsRight__3wlmp"};